module.exports = __webpack_public_path__ + "static/media/mensageiro-send.763e8670.svg";